export default __webpack_public_path__ + "static/media/success.110184d2.webp";